import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async createError({ commit }, payload) {
    let error = {
      source: 'UI',
      message: payload,
    }

    return Vue.axios
      .post(Vue.$url("error-log"), error)
      .then((rsp) => {
        Vue.$log.debug("error created: ", rsp.data.id);
        commit('SET_NOOP');
      })
  },

  async fetchErrors({ commit }) {
    Vue.$log.debug('loading errors');

    return Vue.axios.get(Vue.$url("error-log"))
      .then((rsp) => {
        commit("SET_ERRORS", rsp.data);
        return rsp.data;
      })
  },

  async updateError({ commit }, payload) {
    let silentUpdate = payload.silentUpdate;
    delete payload.silentUpdate;

    return Vue.axios
      .put(Vue.$url("error-log/" + payload.id), payload)
      .then((rsp) => {
        if (!silentUpdate) {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Error', 1: payload.message }), { root: true })
      }
      return rsp.data;
    })
  },

  async deleteError({ commit }, payload) {
    return Vue.axios
      .delete(Vue.$url("error-log/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.deleted', { 0: 'Error', 1: payload.id }), { root: true });
      });
  },
}